import { Alert } from 'antd'
import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'

import { HistoryTimeline } from '@/Ship/Components/History'

import { buildUserHistoryEntries } from '../../Helpers/userHistoryEntries'
import { UserHistoryManager } from '../../Stores/UserHistoryManager'

import type { UserFormContextLike } from '../../Contracts/IUser'

/**
 * Вкладка «Історія змін» (ADR 041): ролі, статус і відділи — хто, коли, що
 * було й що стало. Видно всім, хто читає картку (ВП-7).
 *
 * Стрічку тягнемо на кожне відкриття вкладки (шаблон перемонтовує її
 * ключем): інакше зміна ролей на сусідній вкладці лишилася б невидимою.
 */
export const UserHistoryTab = observer(({ formContext }: { formContext: UserFormContextLike }) => {
    const [manager] = useState(() => new UserHistoryManager())
    const uuid = typeof formContext.values?.uuid === 'string' ? formContext.values.uuid : undefined

    useEffect(() => {
        void manager.load(uuid)
    }, [manager, uuid])

    if (manager.failed) {
        return <Alert type="error" showIcon title="Не вдалося завантажити історію змін." />
    }

    const hidden = manager.total - manager.items.length

    return (
        <HistoryTimeline
            entries={buildUserHistoryEntries(manager.items)}
            loading={manager.isLoading}
            {...(hidden > 0 ? { note: `Показано останні ${manager.items.length} подій із ${manager.total}` } : {})}
        />
    )
})
